export interface ServerInsightData {
  geju?: {
    name: string;
    level: string;
    establishment?: number;
    tendencyText?: string;
    desc?: string;
    traits?: string[];
    career?: string;
    love?: string;
  };
  xiyong?: {
    bodyStrength?: 'strong' | 'weak' | 'neutral';
    wangShuaiLabel?: string;   // 问真 7 档中文
    xi: Array<{ element: string; color: string }>;
    ji: Array<{ element: string; color: string }>;
    advice?: string;
    approaches?: Array<{ label: string; desc: string; xi: Array<{ element: string; color: string }>; ji: Array<{ element: string; color: string }> }>;
  };
  rizhu?: {
    subtitle?: string;
    overview?: string;
    strengths?: string[];
    weaknesses?: string[];
    elementColor?: string;
  };
}

export function mapServerProToInsight(pro: any): ServerInsightData {
  if (!pro) return { geju: undefined, xiyong: undefined, rizhu: undefined };
  const ys = pro.yongShen;
  const toItems = (list: any[]) => (Array.isArray(list) ? list
    .map((it: any) => ({ element: it.value || it.label, color: it.color }))
    .filter((it: any) => it.element) : []);
  const splitItems = (list: any[]) => {
    const xi: Array<{ element: string; color: string }> = [];
    const ji: Array<{ element: string; color: string }> = [];
    (Array.isArray(list) ? list : []).forEach((it: any) => {
      const label = String(it.label || '');
      const element = it.value || label.replace(/^喜用[:：]?/, '').replace(/^忌[:：]?/, '');
      if (!element) return;
      if (label.startsWith('忌')) ji.push({ element, color: it.color });
      else xi.push({ element, color: it.color });
    });
    return { xi, ji };
  };
  const { xi, ji } = splitItems(ys?.items);
  const approaches = Array.isArray(ys?.approaches)
    ? ys.approaches.map((ap: any) => ({
        label: ap.label,
        desc: ap.desc,
        xi: toItems(ap.xi),
        ji: toItems(ap.ji),
      }))
    : undefined;
  const gj = pro.geJu;
  return {
    geju: gj ? {
      name: gj.name,
      level: gj.level,
      establishment: gj.establishment,
      tendencyText: gj.strengthDesc || gj.tendencyText || gj.sub1 || '',
      desc: gj.desc,
      traits: gj.traits,
      career: gj.career,
      love: gj.love,
    } : undefined,
    xiyong: ys ? {
      bodyStrength: ys.bodyStrength,
      wangShuaiLabel: ys.wangShuaiLabel,
      xi: xi.length ? xi : toItems(ys.xi),
      ji: ji.length ? ji : toItems(ys.ji),
      advice: ys.analysis,
      approaches,
    } : undefined,
    rizhu: pro.rizhu?.info ? {
      subtitle: pro.rizhu.info.subtitle,
      overview: pro.rizhu.info.overview,
      strengths: pro.rizhu.info.strengths,
      weaknesses: pro.rizhu.info.weaknesses,
      elementColor: pro.rizhu.info.elementColor,
    } : undefined,
  };
}